import { Link } from 'react-router-dom';
import styles from './ProductAvailability.module.scss';

/**
 * Premium availability card for the product page. When `href` is present the
 * whole card is a single link (e.g. made-to-order products routing to
 * `/products/custom`); otherwise it renders as an inert, non-interactive card.
 */
const ProductAvailability = ({ status, leadTime, description, href }) => {
  const body = (
    <>
      <p className={styles.eyebrow}>Availability</p>
      <p className={styles.status}>
        <span className={styles.statusText}>{status}</span>
        {href ? (
          <span className={styles.arrow} aria-hidden="true">
            →
          </span>
        ) : null}
      </p>
      {leadTime ? (
        <>
          <p className={styles.leadLabel}>Estimated Lead Time</p>
          <p className={styles.leadValue}>{leadTime}</p>
        </>
      ) : null}
      {description ? <p className={styles.description}>{description}</p> : null}
    </>
  );

  if (href) {
    return (
      <Link
        to={href}
        className={`${styles.card} ${styles['card--link']}`}
        aria-label="Learn more about the Sakura Floors made-to-order program"
        data-motion-interactive="press"
      >
        {body}
      </Link>
    );
  }

  return <div className={styles.card}>{body}</div>;
};

export default ProductAvailability;
